// TEMPORAL_RESPALDO_CARGA_MASIVA: archivo exclusivo de la medida preventiva temporal.
// Retirar este archivo junto con las integraciones marcadas al desactivar el respaldo.
import { HttpContextToken } from "@angular/common/http";

// Preserve the gateway response and allow time for the complete backup upload.
export const ES_RESPALDO_CARGA_MASIVA = new HttpContextToken<boolean>(
  () => false,
);
